import { Configuration, CustomElementFactory } from "duice";
import { ElementRegistry } from "duice";
import { PaginationElement } from "./PaginationElement";
/**
 * Pagination Element Factory
 */
export class PaginationElementFactory extends CustomElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    doCreateElement(htmlElement, bindData, context) {
        return new PaginationElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-pagination`, new PaginationElementFactory());
})();
//# sourceMappingURL=PaginationElementFactory.js.map